import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Edit, Trash2 } from "react-feather";
import Table from "../../core/pagination/datatable";
import PageHeader from "../components/PageHeader";
import confirmDelete from "../components/confirmDelete";
import AccountHeadModal from "../../core/modals/account-heads/AccountHeadModal";
import { fetchAccountHeads, deleteAccountHeadThunk } from "../../core/redux/slices/accountHeadSlice";

const AccountHeadList = () => {
  const dispatch = useDispatch();
  const { list, loading } = useSelector((s) => s.accountHeads);
  const [search, setSearch] = useState("");
  const [showModal, setShowModal] = useState(false);
  const [editRecord, setEditRecord] = useState(null);

  useEffect(() => { dispatch(fetchAccountHeads()); }, [dispatch]);

  const data = useMemo(() => {
    const q = search.toLowerCase();
    return list.filter((a) => !q || a.accountName?.toLowerCase().includes(q));
  }, [list, search]);

  const openAdd = () => { setEditRecord(null); setShowModal(true); };
  const openEdit = (rec) => { setEditRecord(rec); setShowModal(true); };
  const closeModal = () => { setShowModal(false); setEditRecord(null); dispatch(fetchAccountHeads()); };

  const columns = [
    { title: "Account Name", dataIndex: "accountName", sorter: (a, b) => a.accountName.localeCompare(b.accountName) },
    { title: "Description", dataIndex: "description", ellipsis: true },
    { title: "Status", dataIndex: "status", width: 90,
      render: (v) => <span className={`badge bg-${v === "Active" ? "success" : "danger"}`}>{v}</span> },
    {
      title: "Action", dataIndex: "action", width: 100,
      render: (_, rec) => (
        <div className="edit-delete-action d-flex">
          <button className="me-2 p-2 btn btn-sm" onClick={() => openEdit(rec)}><Edit size={15} /></button>
          <button className="p-2 btn btn-sm text-danger" onClick={() => confirmDelete(() => dispatch(deleteAccountHeadThunk(rec.id)), rec.accountName)}>
            <Trash2 size={15} />
          </button>
        </div>
      ),
    },
  ];

  return (
    <div className="page-wrapper">
      <div className="content">
        <PageHeader title="Account Heads" subtitle="Manage expense and income account heads" onAdd={openAdd} addLabel="Add Account Head" />
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-input">
                <input type="text" placeholder="Search account heads..."
                  className="form-control form-control-sm formsearch"
                  value={search} onChange={(e) => setSearch(e.target.value)} />
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={data} loading={loading} />
            </div>
          </div>
        </div>
      </div>
      <AccountHeadModal show={showModal} onClose={closeModal} editRecord={editRecord} />
    </div>
  );
};

export default AccountHeadList;
